import { DEFAULT_LOCALE, type Locale, RTL_LOCALES, SUPPORTED_LOCALES } from '@cf/shared';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { ar } from './ar';
import { fr } from './fr';

const STORAGE_KEY = 'cf.locale';

const stored = (() => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
})();
/** True once a language was chosen on this device (login-page selector, or a previous session). */
export function hasLocalLocaleChoice(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) != null;
  } catch {
    return false;
  }
}

const initial: Locale = (SUPPORTED_LOCALES as readonly string[]).includes(stored ?? '')
  ? (stored as Locale)
  : DEFAULT_LOCALE;

/** Keeps <html lang/dir> in sync so Tailwind logical utilities (ms-*, pe-*, text-start) flip for RTL. */
function applyDocumentLocale(locale: string) {
  document.documentElement.lang = locale;
  document.documentElement.dir = (RTL_LOCALES as readonly string[]).includes(locale)
    ? 'rtl'
    : 'ltr';
}

void i18n.use(initReactI18next).init({
  resources: { fr: { translation: fr }, ar: { translation: ar } },
  lng: initial,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
});
applyDocumentLocale(initial);

i18n.on('languageChanged', (lng) => {
  applyDocumentLocale(lng);
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    /* private mode */
  }
});

export default i18n;
